"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GraphQLSubscriptionExtension = function GraphQLSubscriptionExtension() {
  var LOGGER = new _amb.default('amb.GraphQLSubscriptionExtension');
  var RW_GRAPHQL_CHANNEL = '/rw/graphql';
  var META_SUBSCRIBE = '/meta/subscribe';
  var graphQLSubscriptions = {};

  this.isGraphQLChannel = function (channel) {
    return channel && channel.startsWith(RW_GRAPHQL_CHANNEL);
  };

  this.addGraphQLChannel = function (channel, graphQLSubscription) {
    graphQLSubscriptions[channel] = graphQLSubscription;
  };

  this.removeGraphQLChannel = function (channel) {
    delete graphQLSubscriptions[channel];
  };

  this.getGraphQLSubscriptions = function () {
    return graphQLSubscriptions;
  };

  this.outgoing = function (message) {
    if (message.channel === META_SUBSCRIBE && this.isGraphQLChannel(message.subscription)) {
      if (!message.ext) message.ext = {};

      if (graphQLSubscriptions[message.subscription]) {
        LOGGER.debug('Subscribing with GraphQL subscription:' + graphQLSubscriptions[message.subscription]);
        message.ext.serializedGraphQLSubscription = graphQLSubscriptions[message.subscription];
      }
    }

    return message;
  };
};

var _default = GraphQLSubscriptionExtension;
exports.default = _default;